/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ConfirmOrderPayPaymentData,
  CreateOrderPayAccountData,
  CreateOrderPayAccountStatusEnum2,
  CreateOrderPayAccountStatusEnum3,
  CreateOrderPayAccountUnitEnum2,
  CreateOrderPayAccountUnitEnum3,
  CreateOrderPayPaymentData,
  CreateOrderPayPaymentPaymentMethodEnum1,
  CreateOrderPayPaymentPspEnum1,
  GetOrderPayAccountData,
  PatchOrderPayAccountData,
  PatchOrderPayAccountStatusEnum2,
  UpdateOrderPayItemsQuantitiesByBrandData,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class OrderPay<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
 * @description Create an OrderPay account for the currently logged-in brand. The acceptance of the Terms and Conditions is implicit. If no version is specified, the latest terms version is used by default. It means the resource attributes can be left empty, as illustrated in the request example below. ```json { "data": { "type": "order-pay-account" } } ``` When an account already exists for the brand, the request fails with a "409 Conflict" error.
 *
 * @tags AnkorstoreInternal_OrderPay
 * @name CreateOrderPayAccount
 * @summary Sign up for OrderPay
 * @request POST:/api/internal/v1/order-pay/accounts
 * @response `201` `CreateOrderPayAccountData` Returns a single account resource.
 * @response `400` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Bad request
 * @response `401` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unauthorized
 * @response `403` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Forbidden
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `409` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Conflict
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 * @response `500` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Server Error
 */
  createOrderPayAccount = (
    data: {
      /** OrderPayAccountResource */
      data?: {
        type: 'order-pay-account';
        /**
         * A globally-unique identifier for the account.
         * @format uuid
         * @example "1ef077c4-f8a1-6bc8-9ac6-4e29ff3d1748"
         */
        id?: string;
        attributes?: {
          status?: CreateOrderPayAccountStatusEnum2;
          /**
           * Date when the account was created.
           * @format date-time
           */
          createdAt?: string;
          /** The user's acceptance of the terms and conditions. */
          termsAcceptance?: {
            /**
             * The version of the terms and conditions. Defaults to the latest version.
             * @example "2025.04"
             */
            termsVersion?: string;
            /**
             * Date when the user accepted the terms and conditions.
             * @format date-time
             */
            acceptedAt?: string;
          } | null;
          subscription?: {
            /** The current status of the subscription. */
            status?: CreateOrderPayAccountStatusEnum3;
            /**
             * Date when the subscription started or `null` if it hasn't started yet.
             * @format date-time
             */
            startedAt?: null | string;
            /**
             * Date when the subscription has ended or `null` if it's active.
             * @format date-time
             */
            expiresAt?: null | string;
            /** The recurring frequency with which the subscription is charged. */
            billingCycle?: {
              /**
               * Amount of time.
               * @min 0
               */
              amount?: number;
              /** Unit of time. */
              unit?: CreateOrderPayAccountUnitEnum2;
            };
            /** The trial period or `null` if there is no trial for this subscription. */
            trialPeriod?: {
              /** The duration of the trial period if any. */
              duration?: {
                /**
                 * Amount of time.
                 * @min 0
                 */
                amount?: number;
                /** Unit of time. */
                unit?: CreateOrderPayAccountUnitEnum3;
              };
              /**
               * Date when the trial period has started.
               * @format date-time
               */
              startedAt?: null | string;
              /**
               * Date when the trial period has expired.
               * @format date-time
               */
              expiresAt?: null | string;
            };
          };
        };
      };
    },
    params: RequestParams = {}
  ) =>
    this.request<
      CreateOrderPayAccountData,
      {
        /** @uniqueItems true */
        errors: {
          /** An application-specific error code, expressed as a string value. */
          code?: string;
          /** A human-readable explanation specific to this occurrence of the problem. */
          detail?: string;
          /** The HTTP status code applicable to this problem, expressed as a string value. */
          status?: string;
          /** The HTTP status code description applicable to this problem */
          title?: string;
          /** Optional object pointing towards the problematic field */
          source?: {
            /** The field key */
            pointer?: string;
          };
        }[];
        /** An object describing the server's implementation */
        jsonapi?: {
          /** @example "1.0" */
          version?: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      }
    >({
      path: `/api/internal/v1/order-pay/accounts`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
 * @description Retrieve the details of an OrderPay account. <div class="info"> **Pro tip**: The brand and OrderPay accounts share the same globally-unique identifier (UUID). Simply use the brand identifier to retrieve the OrderPay account details. </div>
 *
 * @tags AnkorstoreInternal_OrderPay
 * @name GetOrderPayAccount
 * @summary Retrieve account details
 * @request GET:/api/internal/v1/order-pay/accounts/{id}
 * @response `200` `GetOrderPayAccountData` Returns a single account resource.
 * @response `400` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Bad request
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 * @response `500` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Server Error
 */
  getOrderPayAccount = (id: string, params: RequestParams = {}) =>
    this.request<
      GetOrderPayAccountData,
      {
        /** @uniqueItems true */
        errors: {
          /** An application-specific error code, expressed as a string value. */
          code?: string;
          /** A human-readable explanation specific to this occurrence of the problem. */
          detail?: string;
          /** The HTTP status code applicable to this problem, expressed as a string value. */
          status?: string;
          /** The HTTP status code description applicable to this problem */
          title?: string;
          /** Optional object pointing towards the problematic field */
          source?: {
            /** The field key */
            pointer?: string;
          };
        }[];
        /** An object describing the server's implementation */
        jsonapi?: {
          /** @example "1.0" */
          version?: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      }
    >({
      path: `/api/internal/v1/order-pay/accounts/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
 * @description Update subscription status of an OrderPay account. If the brand status is churned, it can be reactivated. If the brand status is active, it can be cancelled.
 *
 * @tags AnkorstoreInternal_OrderPay
 * @name PatchOrderPayAccount
 * @summary Patch OrderPay account
 * @request PATCH:/api/internal/v1/order-pay/accounts/{id}
 * @response `200` `PatchOrderPayAccountData` Returns a single account resource.
 * @response `400` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Bad request
 * @response `401` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unauthorized
 * @response `403` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Forbidden
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 * @response `422` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unprocessable Entity : Data provided is invalid
 * @response `500` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Server Error
 */
  patchOrderPayAccount = (
    id: string,
    data: {
      /** UpdateOrderPayAccountResource */
      data?: {
        type: 'order-pay-account';
        /**
         * A globally-unique identifier for the account.
         * @format uuid
         * @example "1ef077c4-f8a1-6bc8-9ac6-4e29ff3d1748"
         */
        id?: string;
        attributes?: {
          /** Subscription information for the account (read-only). */
          subscription?: {
            /** The status expected for the subscription. */
            status?: PatchOrderPayAccountStatusEnum2;
          };
        };
      };
    },
    params: RequestParams = {}
  ) =>
    this.request<
      PatchOrderPayAccountData,
      {
        /** @uniqueItems true */
        errors: {
          /** An application-specific error code, expressed as a string value. */
          code?: string;
          /** A human-readable explanation specific to this occurrence of the problem. */
          detail?: string;
          /** The HTTP status code applicable to this problem, expressed as a string value. */
          status?: string;
          /** The HTTP status code description applicable to this problem */
          title?: string;
          /** Optional object pointing towards the problematic field */
          source?: {
            /** The field key */
            pointer?: string;
          };
        }[];
        /** An object describing the server's implementation */
        jsonapi?: {
          /** @example "1.0" */
          version?: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      }
    >({
      path: `/api/internal/v1/order-pay/accounts/${id}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
 * @description It creates a new OrderPay payment and transaction and sends it to the payment provider. It returns the payment and transaction objects, with the payment provider required data.
 *
 * @tags AnkorstoreInternal_OrderPay
 * @name CreateOrderPayPayment
 * @summary Create an OrderPay payment
 * @request POST:/api/internal/v1/order-pay/order-pay-payments
 * @response `201` `CreateOrderPayPaymentData` OrderPay payment response
 * @response `400` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Bad request
 * @response `404` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not found
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `409` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Conflict
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 * @response `422` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unprocessable Entity : Data provided is invalid
 * @response `500` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Server Error
 */
  createOrderPayPayment = (
    data: {
      data: {
        type: 'order-pay-payments';
        attributes: {
          /**
           * External order uuid
           * @format uuid
           */
          orderUuid: string;
          psp: CreateOrderPayPaymentPspEnum1;
          /**
           * OrderPay customer uuid (external)
           * @format uuid
           */
          customerUuid: string;
          paymentMethod: CreateOrderPayPaymentPaymentMethodEnum1;
          fundedBy?: string;
          paymentTerms?: string;
          /**
           * Required if payment method is sepa_direct_debit. Indicates if the backend should create a new payment method (perform a setup_intent on Stripe), or use the existing sepa debit payment method.
           * @default false
           */
          withNewPaymentMethod?: boolean;
        };
      };
    },
    params: RequestParams = {}
  ) =>
    this.request<
      CreateOrderPayPaymentData,
      {
        /** @uniqueItems true */
        errors: {
          /** An application-specific error code, expressed as a string value. */
          code?: string;
          /** A human-readable explanation specific to this occurrence of the problem. */
          detail?: string;
          /** The HTTP status code applicable to this problem, expressed as a string value. */
          status?: string;
          /** The HTTP status code description applicable to this problem */
          title?: string;
          /** Optional object pointing towards the problematic field */
          source?: {
            /** The field key */
            pointer?: string;
          };
        }[];
        /** An object describing the server's implementation */
        jsonapi?: {
          /** @example "1.0" */
          version?: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      }
    >({
      path: `/api/internal/v1/order-pay/order-pay-payments`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
 * @description It confirms an initiated OrderPay payment and triggers the whole confirmation flow (communications, order workflow, fulfillment). It returns the payment and transaction objects if included.
 *
 * @tags AnkorstoreInternal_OrderPay
 * @name ConfirmOrderPayPayment
 * @summary Confirm an OrderPay payment
 * @request PATCH:/api/internal/v1/order-pay/order-pay-payments/{id}/-actions/confirm
 * @response `201` `ConfirmOrderPayPaymentData` OrderPay payment response
 * @response `400` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Bad request
 * @response `404` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not found
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `409` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Conflict
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 * @response `422` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unprocessable Entity : Data provided is invalid
 * @response `500` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Server Error
 */
  confirmOrderPayPayment = (id: string, params: RequestParams = {}) =>
    this.request<
      ConfirmOrderPayPaymentData,
      {
        /** @uniqueItems true */
        errors: {
          /** An application-specific error code, expressed as a string value. */
          code?: string;
          /** A human-readable explanation specific to this occurrence of the problem. */
          detail?: string;
          /** The HTTP status code applicable to this problem, expressed as a string value. */
          status?: string;
          /** The HTTP status code description applicable to this problem */
          title?: string;
          /** Optional object pointing towards the problematic field */
          source?: {
            /** The field key */
            pointer?: string;
          };
        }[];
        /** An object describing the server's implementation */
        jsonapi?: {
          /** @example "1.0" */
          version?: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      }
    >({
      path: `/api/internal/v1/order-pay/order-pay-payments/${id}/-actions/confirm`,
      method: 'PATCH',
      format: 'json',
      ...params,
    });
  /**
 * @description Allows brand to update order items quantities
 *
 * @tags AnkorstoreInternal_OrderPay
 * @name UpdateOrderPayItemsQuantitiesByBrand
 * @summary Update Order content
 * @request PATCH:/api/internal/v1/order-pay/order-pay-orders/{id}/-actions/quantities
 * @response `200` `UpdateOrderPayItemsQuantitiesByBrandData` OrderPay ExternalOrder data
 * @response `400` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Bad request
 * @response `401` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unauthorized
 * @response `403` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Forbidden
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 * @response `422` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unprocessable Entity : Data provided is invalid
 * @response `500` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Server Error
 */
  updateOrderPayItemsQuantitiesByBrand = (
    id: string,
    data: {
      data: {
        type: 'order-pay-orders';
        attributes: {
          /** List of items with their corresponding quantities. */
          items: {
            /**
             * Product variant UUID.
             * @format uuid
             */
            productVariantUuid: string;
            /**
             * Unit Quantity of the items
             * @example 2
             */
            quantity: number;
          }[];
        };
      };
    },
    params: RequestParams = {}
  ) =>
    this.request<
      UpdateOrderPayItemsQuantitiesByBrandData,
      {
        /** @uniqueItems true */
        errors: {
          /** An application-specific error code, expressed as a string value. */
          code?: string;
          /** A human-readable explanation specific to this occurrence of the problem. */
          detail?: string;
          /** The HTTP status code applicable to this problem, expressed as a string value. */
          status?: string;
          /** The HTTP status code description applicable to this problem */
          title?: string;
          /** Optional object pointing towards the problematic field */
          source?: {
            /** The field key */
            pointer?: string;
          };
        }[];
        /** An object describing the server's implementation */
        jsonapi?: {
          /** @example "1.0" */
          version?: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      }
    >({
      path: `/api/internal/v1/order-pay/order-pay-orders/${id}/-actions/quantities`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
